import { render } from "./BudgetEditor.vue?vue&type=template&id=ca3908ae"
import script from "./BudgetEditor.vue?vue&type=script&lang=js"
export * from "./BudgetEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/BudgetEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ca3908ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca3908ae', __exports__)) {
    api.reload('ca3908ae', __exports__)
  }
  
  module.hot.accept("./BudgetEditor.vue?vue&type=template&id=ca3908ae", () => {
    api.rerender('ca3908ae', render)
  })

}


export default __exports__